var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgContactUs = function SvgContactUs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2v3.5M19 13c0-4.418-4.582-7-8-7s-8 2.582-8 7M.9 19.25l.825-4.5h18.55l.825 4.5H.9ZM8 2h6",
    stroke: "#000",
    strokeWidth: 1.5
  })));
};
export default SvgContactUs;